// ONE announcement per corrected capture, across every surface (#825 phase 3).
// A capture made in the chat inside a booked lesson carries BOTH a lessonId and
// a source message, so the broadcaster fires both topics — and in the classroom
// the notes editor and the chat panel are independent panes, each with its own
// listener. Without a shared claim the same completion is announced twice, with
// two competing Keep-my-spelling actions. Whichever surface claims the entry id
// first says it; the other stands down, whatever is mounted.
//
// Keyed by entry id, so a genuine second capture of the same word (its own
// entry) is still announced. Module-level and intentionally session-lived: it
// is also what keeps re-entering a room, or reopening a conversation, from
// re-announcing yesterday's corrections.
//
// Its own module rather than a corner of vocabulary-entries.ts because the
// vitest setup file imports it for every suite (see below) and that module
// reaches @/lib/graphql, which builds an Apollo client and an ActionCable
// consumer the moment it is imported.
const announcedCorrections = new Set<string>()

export function claimCorrectionAnnouncement(entryId: string): boolean {
  if (announcedCorrections.has(entryId)) return false
  announcedCorrections.add(entryId)
  return true
}

// Specs only, and called for every spec from app/frontend/__tests__/setup.ts:
// the set outlives any component, so without a reset between cases a spec that
// reuses an entry id would stand down and pass for the wrong reason.
export function resetCorrectionAnnouncements(): void {
  announcedCorrections.clear()
}
